import React from 'react';
import { Redirect, Route, useRouteMatch } from 'react-router-dom';
import { CommonQuestionRoutes } from './CommonQuestions/commonQuestions.routes';
import { Contact } from './Contact';

export enum EHelpCenterRoutes {
  CONTACT = '/contact',
  COMMON_QUESTIONS = '/common-questions',
  HELP_MANUALS = '/help-manuals'
}

export const HelpCenterRoutes: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Route exact path={`${path}`}>
        <Redirect to={`${path}${EHelpCenterRoutes.HELP_MANUALS}`} />
      </Route>

      <Route
        exact
        path={`${path}${EHelpCenterRoutes.CONTACT}`}
        component={Contact}
      />

      <Route
        path={`${path}${EHelpCenterRoutes.COMMON_QUESTIONS}`}
        component={CommonQuestionRoutes}
      />
    </>
  );
};
